import React from 'react';
import SurveyService from '../Services/surveyService';
import ErrorMessage from './ErrorMessage';
import { cachedLookup } from '../Helpers/lookupCache';

export default class SurveyNameComponent extends React.Component {
  static defaultProps = {
    surveyId: null,
    projectId: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      surveyName: props.surveyId,
    };
  }

  componentDidMount() {
    this.populateName();
  }

  componentDidUpdate(nextProps) {
    if (this.props.surveyId !== nextProps.surveyId) {
      this.populateName();
    }
  }

  populateName() {
    if (!this.props.surveyId) return null;
    cachedLookup(SurveyService.getSurveyBySassieId, this.props.surveyId, SurveyService.getSurveyBySassieId)
      .then((result) => {
        //this.setState({surveyName: result.name})
        if (this.props.projectId) this.setState({ surveyName: `${result.name} (${this.props.projectId})` });
        else this.setState({ surveyName: `${result.name} (${this.props.surveyId})` });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('SNC43'));
  }

  render() {
    return <div>{this.state.surveyName}</div>;
  }
}
